var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 6.16321C13.1604 6.16321 14.1004 7.10321 14.1004 8.26321C14.1004 9.42321 13.1604 10.3632 12.0004 10.3632C10.8404 10.3632 9.90039 9.42321 9.90039 8.26321C9.90039 7.10321 10.8404 6.16321 12.0004 6.16321ZM12.0004 15.1632C14.9704 15.1632 18.1004 16.6232 18.1004 17.2632V18.3632H5.90039V17.2632C5.90039 16.6232 9.03039 15.1632 12.0004 15.1632ZM12 4.26331C9.79 4.26331 8 6.05331 8 8.26331C8 10.4733 9.79 12.2633 12 12.2633C14.21 12.2633 16 10.4733 16 8.26331C16 6.05331 14.21 4.26331 12 4.26331ZM12 13.2633C9.33 13.2633 4 14.6033 4 17.2633V19.2633C4 19.8133 4.45 20.2633 5 20.2633H19C19.55 20.2633 20 19.8133 20 19.2633V17.2633C20 14.6033 14.67 13.2633 12 13.2633Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirStaff);
export default __webpack_public_path__ + "static/media/mir_staff.16ab7e31d0b38928c4e6314c1f99e061.svg";
export { ForwardRef as ReactComponent };